import styled from 'styled-components/macro'

const GitHubLogo = styled('img')`
  width: 24px;
  display: inline-block;
  vertical-align: middle;
  margin-right: ${props => props.theme.spacing.unit}px;
`

export default GitHubLogo
